import React from "react";
import { createApi } from "../../../utils/createApi";
import { getNumbersAfterSites } from "../EditCamera";
import { AxiosError, AxiosResponse } from "axios";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import { NavigateFunction } from "react-router-dom";

/**
 * All of the site's webhooks, for the stream-webhook dialogs' picker. An
 * empty list is a normal answer (the site has none yet — the dialog shows
 * where to add one), so only a failed request goes through the error handler.
 */
export const getCustomerWebhooks = (
  navigate: NavigateFunction,
  setCustomerWebhooks: any,
  onSettled?: () => void
) => {
  const AxiosUI = createApi("");

  const retryFunction = () => {
    getCustomerWebhooks(navigate, setCustomerWebhooks, onSettled);
  };

  AxiosUI.get(
    `webhook_customer/?customer=${getNumbersAfterSites(location.href)}`
  ).then(
    (response: AxiosResponse) => {
      setCustomerWebhooks(Array.isArray(response.data) ? response.data : []);
      onSettled?.();
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setCustomerWebhooks([]);
        onSettled?.();
      });
    }
  );
};
